module.exports = __webpack_public_path__ + "static/media/tension2.47fee4de.webp";